import React, { useState } from "react";
import Container from "../components/layout/Container";
import { sendContactMessage } from "../services/api";
import { useTranslation } from "../hooks/useTranslation";
import { 
    FaPhone, 
    FaEnvelope, 
    FaMapMarkerAlt, 
    FaClock,
    FaCheckCircle,
    FaExclamationTriangle 
} from "react-icons/fa";

const Contact = () => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        name: "",
        phone_or_email: "",
        message: ""
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setSuccess(false);

        try {
            await sendContactMessage(formData);
            setSuccess(true);
            setFormData({ name: "", phone_or_email: "", message: "" });
        } catch (err) {
            setError(t('common.error'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-red-50/30 to-red-100/20">
            <Container className="py-6">
                <div className="py-16">
                    {/* Header */}
                    <div className="text-center mb-16">
                        <h1 className="text-4xl font-bold text-gray-900 mb-4">{t('pages.contact.title')}</h1>
                        <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
                            {t('pages.contact.subtitle')}
                        </p>
                        <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-red-600 mx-auto rounded-full"></div>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
                        {/* Contact Info */}
                        <div className="lg:col-span-1">
                            <div className="bg-gradient-to-br from-red-50/90 via-white/80 to-red-50/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-red-200/30 p-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-8">{t('pages.contact.contactInfo')}</h2>
                                
                                <div className="space-y-6">
                                    <div className="flex items-start">
                                        <div className="bg-red-100 p-3 rounded-full mr-4 flex-shrink-0">
                                            <FaPhone className="text-red-600 w-5 h-5" />
                                        </div>
                                        <div>
                                            <h3 className="font-semibold text-gray-900 mb-1">{t('pages.contact.phone')}</h3>
                                            <div className="mb-2">
                                                <p className="text-gray-600">+998 98 100 10 10</p>
                                                <p className="text-sm text-gray-500">Call Center</p>
                                            </div>
                                            <div>
                                                <p className="text-gray-600">+998 88 907 10 10</p>
                                                <p className="text-gray-600">+998 88 715 10 10</p>
                                                <p className="text-sm text-gray-500">Service Center</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="bg-red-100 p-3 rounded-full mr-4 flex-shrink-0">
                                            <FaEnvelope className="text-red-600 w-5 h-5" />
                                        </div>
                                        <div>
                                            <h3 className="font-semibold text-gray-900 mb-1">{t('pages.contact.email')}</h3>
                                            <p className="text-gray-600">bruceuzbekistan1@gmail.com</p>
                                            <p className="text-sm text-gray-500">İletişim & Destek</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="bg-red-100 p-3 rounded-full mr-4 flex-shrink-0">
                                            <FaMapMarkerAlt className="text-red-600 w-5 h-5" />
                                        </div>
                                        <div>
                                            <h3 className="font-semibold text-gray-900 mb-1">{t('pages.contact.address')}</h3>
                                            <p className="text-gray-600">
                                                Navbahor koʻchasi 66 uy,<br />
                                                Kokand, Fergana,<br />
                                                Uzbekistan
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="bg-red-100 p-3 rounded-full mr-4 flex-shrink-0">
                                            <FaClock className="text-red-600 w-5 h-5" />
                                        </div>
                                        <div>
                                            <h3 className="font-semibold text-gray-900 mb-1">{t('pages.contact.workingHours')}</h3>
                                            <p className="text-gray-600">Dushanba - Juma: 9:00 - 18:00</p>
                                            <p className="text-gray-600">Shanba: 9:00 - 14:00</p>
                                            <p className="text-gray-600">Yakshanba: Dam olish</p>
                                        </div>
                                    </div>
                                </div>

                                {/* CTA Section */}
                                <div className="mt-8 p-6 bg-gradient-to-r from-red-600 to-red-700 rounded-xl text-white">
                                    <h3 className="font-bold text-lg mb-2">Tezkor javob</h3>
                                    <p className="text-sm opacity-90 mb-4">
                                        24 soat ichida sizning xabaringizga javob beramiz
                                    </p>
                                    <div className="flex items-center text-sm">
                                        <FaCheckCircle className="mr-2" />
                                        Professional maslahat
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact Form */}
                        <div className="lg:col-span-2">
                            <div className="bg-gradient-to-br from-red-50/90 via-white/80 to-red-50/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-red-200/30 p-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-8">{t('pages.contact.send')}</h2>
                                
                                {success && (
                                    <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg flex items-center">
                                        <FaCheckCircle className="mr-3 flex-shrink-0" />
                                        <div>
                                            <strong>Muvaffaqiyatli!</strong> Xabaringiz yuborildi. Tez orada siz bilan bog'lanamiz.
                                        </div>
                                    </div>
                                )}

                                {error && (
                                    <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg flex items-center">
                                        <FaExclamationTriangle className="mr-3 flex-shrink-0" />
                                        <div>{error}</div>
                                    </div>
                                )}

                                <form onSubmit={handleSubmit} className="space-y-6">
                                    <div>
                                        <label htmlFor="name" className="block text-sm font-semibold text-gray-900 mb-2">
                                            {t('pages.contact.name')} *
                                        </label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-colors duration-300"
                                            placeholder="To'liq ismingizni kiriting"
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="phone_or_email" className="block text-sm font-semibold text-gray-900 mb-2">
                                            {t('pages.contact.phone')} / {t('pages.contact.email')} *
                                        </label>
                                        <input
                                            type="text"
                                            id="phone_or_email"
                                            name="phone_or_email"
                                            value={formData.phone_or_email}
                                            onChange={handleChange}
                                            required
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-colors duration-300"
                                            placeholder="+998 XX XXX XX XX yoki email@example.com"
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="message" className="block text-sm font-semibold text-gray-900 mb-2">
                                            {t('pages.contact.message')} *
                                        </label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                            rows={6}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-colors duration-300"
                                            placeholder="Sizni qiziqtirgan mahsulot yoki xizmat haqida batafsil yozing..."
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className={`w-full py-4 px-6 rounded-lg font-semibold text-white transition-all duration-300 transform hover:scale-105 ${
                                            loading
                                                ? "bg-gray-400 cursor-not-allowed"
                                                : "bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 shadow-lg hover:shadow-xl"
                                        }`}
                                    >
                                        {loading ? (
                                            <div className="flex items-center justify-center">
                                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                                                {t('common.loading')}...
                                            </div>
                                        ) : (
                                            t('pages.contact.send')
                                        )}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>

                    {/* Map Section */}
                    <div className="mt-16">
                        <div className="bg-gradient-to-br from-red-50/90 via-white/80 to-red-50/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-red-200/30 overflow-hidden">
                            <div className="h-96 relative">
                                <iframe 
                                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3031.6123414866997!2d70.9572920760176!3d40.55015297141855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDDCsDMzJzAwLjYiTiA3MMKwNTcnMzUuNSJF!5e0!3m2!1str!2str!4v1754149076801!5m2!1str!2str" 
                                    width="100%" 
                                    height="100%" 
                                    style={{border: 0}}
                                    allowFullScreen="" 
                                    loading="lazy" 
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Bruce Uzbekistan Konum"
                                    className="rounded-2xl"
                                ></iframe>
                                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm rounded-xl p-3 shadow-lg">
                                    <div className="flex items-center text-sm">
                                        <FaMapMarkerAlt className="text-red-500 mr-2" />
                                        <div>
                                            <p className="font-semibold">Bruce Uzbekistan</p>
                                            <p className="text-gray-600">Kokand, Fergana</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* FAQ Section */}
                    <div className="mt-16">
                        <div className="text-center mb-12">
                            <h2 className="text-3xl font-bold text-gray-900 mb-4">Ko'p So'raladigan Savollar</h2>
                            <p className="text-xl text-gray-600">Eng tez-tez beriladigan savollar va javoblar</p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div className="bg-gradient-to-br from-red-50/90 via-white/80 to-red-50/90 backdrop-blur-xl rounded-2xl shadow-lg border border-red-200/30 p-6">
                                <h3 className="font-bold text-lg text-gray-900 mb-3">Buyurtma qanday beriladi?</h3>
                                <p className="text-gray-600">
                                    Buyurtma berish uchun bizning mahsulotlar sahifasiga o'ting, kerakli mahsulotni tanlang 
                                    va biz bilan bog'laning. Mutaxassislarimiz sizga yordam beradi.
                                </p>
                            </div>
                            <div className="bg-gradient-to-br from-red-50/90 via-white/80 to-red-50/90 backdrop-blur-xl rounded-2xl shadow-lg border border-red-200/30 p-6">
                                <h3 className="font-bold text-lg text-gray-900 mb-3">Yetkazib berish qancha vaqt oladi?</h3>
                                <p className="text-gray-600">
                                    Yetkazib berish vaqti mahsulot turiga va joylashuvga qarab 1-7 ish kuni orasida. 
                                    Aniq vaqt buyurtma berishda ma'lum qilinadi.
                                </p>
                            </div>
                            <div className="bg-gradient-to-br from-red-50/90 via-white/80 to-red-50/90 backdrop-blur-xl rounded-2xl shadow-lg border border-red-200/30 p-6">
                                <h3 className="font-bold text-lg text-gray-900 mb-3">Kafolat muddati qancha?</h3>
                                <p className="text-gray-600">
                                    Barcha mahsulotlarimizga 12 oy kafolat beramiz. Kafolat muddatida bepul ta'mirlash 
                                    yoki almashtiriladi.
                                </p>
                            </div>
                            <div className="bg-gradient-to-br from-red-50/90 via-white/80 to-red-50/90 backdrop-blur-xl rounded-2xl shadow-lg border border-red-200/30 p-6">
                                <h3 className="font-bold text-lg text-gray-900 mb-3">To'lov usullari qanday?</h3>
                                <p className="text-gray-600">
                                    Naqd pul, bank o'tkazmasi, plastik kartalar orqali to'lov qabul qilamiz. 
                                    Sizga qulay usulni tanlashingiz mumkin.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default Contact;
